import React, { useEffect, useState } from 'react';
import { Package, Calendar } from 'lucide-react';

/**
 * Vignette liste Mes Commandes — présentation uniquement (produit ou prestation).
 */
const SIZE_CLASS = {
  default: 'w-12 h-12 sm:w-[3.25rem] sm:h-[3.25rem]',
  reference: 'w-14 h-14 sm:w-16 sm:h-16',
  maquette: 'w-[4.5rem] h-[4.5rem] sm:w-[5rem] sm:h-[5rem]',
};

export default function MesCommandesItemThumb({
  variant = 'product',
  size = 'default',
  imageUrl = null,
  extraProductCount = 0,
  accentColor = '#6366f1',
  alt = '',
}) {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  useEffect(() => {
    setImageLoadFailed(false);
  }, [imageUrl]);

  const showBadge = variant === 'product' && extraProductCount > 0;
  const dim = SIZE_CLASS[size] || SIZE_CLASS.default;
  const showImage = Boolean(imageUrl) && !imageLoadFailed;
  const useRdvAccentFallback = variant === 'rdv' && !showImage;

  return (
    <div className={`relative flex-shrink-0 ${dim}`}>
      <div
        className={`w-full h-full rounded-xl border border-gray-200 overflow-hidden flex items-center justify-center shadow-md ring-1 ring-black/5 ${
          variant === 'product' && !showImage ? 'bg-gray-50' : ''
        }`}
        style={
          useRdvAccentFallback
            ? { backgroundColor: `${accentColor}22`, borderColor: `${accentColor}55` }
            : undefined
        }
      >
        {showImage ? (
          <img
            src={imageUrl}
            alt={alt}
            className="w-full h-full object-cover"
            loading="lazy"
            onError={() => setImageLoadFailed(true)}
          />
        ) : variant === 'rdv' ? (
          <Calendar className="h-5 w-5" style={{ color: accentColor }} aria-hidden />
        ) : (
          <Package className="h-6 w-6 text-gray-400" aria-hidden />
        )}
      </div>
      {showBadge ? (
        <span
          className="absolute -bottom-0.5 -right-0.5 min-w-[1.125rem] px-1 py-px rounded bg-primary-700 text-white text-[10px] font-semibold text-center leading-tight shadow-sm ring-1 ring-white"
          title={`${extraProductCount} article(s) supplémentaire(s)`}
        >
          +{extraProductCount}
        </span>
      ) : null}
    </div>
  );
}
